// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"link_shadow__kN_Ic","link":"link_link__2n7ze","box":"link_box__2D66T"};